const courseCategories = [
  { id: 1, value: 'In house training' },
  { id: 2, value: 'Safety' },
  { id: 3, value: 'Skills' }
];

export default { courseCategories };
